<template>
    <div>
      <v-row>
        <v-col cols="6">
        </v-col>
        <v-col cols="6">
          <div
            class="elitigation-block question row"
          >
            <div class="col-6 judicial-department">
              <span>{{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.bankruptcyPreparationDepartment}}</span>
            </div>
            <div class="col-6">
              <span class="float-left">{{ toHijriDate(infoItem.questionDate) }}</span>
            </div>
            <div class="col-12">
              <span> {{infoItem.questionText}} </span>
            </div>
            <div class="next-icon">
              <v-icon>
                mdi-keyboard-return
              </v-icon>
            </div>
            <div
              v-if="infoItem.isMyQuestion"
              class="reply-button-container row">
              <div class="col-6">
            
                <div
                  v-if="!infoItem.isAllowedAttachment"
                >
                  <span class="attach-file">
                    <v-icon>
                      mdi-paperclip
                    </v-icon>
                    {{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.cannotAttachFile}}
                  </span>
                </div>
                <span
                  v-if="infoItem.isMyQuestion"
                >
                  {{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.lastReplyDate}}: {{ toHijriDate(infoItem.questionExpirationDate) }}
                </span>
              </div>
              <div class="col-6">
                <naj-button
                  
                  size="small"
                  class="float-left"
                  :disabled="infoItem.isQuestionAnswered || infoItem.questionExpirationDate < new Date().toISOString() || infoItem.sessionStatusId !== sessionStatus.inProgress"
                  @click="replyQuestion(infoItem)"
                >
                  {{ local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.reply }}
                </naj-button>
              </div>
            </div>
            <div
              v-if="!infoItem.isMyQuestion"
              class="col-11"
            >
              {{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.whoReplies}}: <span class="person-name" >{{ infoItem.fullName }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <div
            v-if="infoItem.isQuestionAnswered"
            class="elitigation-block row"
          >
            <div class="col-6 judicial-department">
              <span>{{this.infoItem.fullName}}</span>
            </div>
            <div class="col-6">
              <span class="float-left">{{ toHijriDate(infoItem.answerDate) }}</span>
            </div>
            <div class="col-12">
              <div
                class="elitigation-block answer"
              >
                <div class="col-12 judicial-department">
                  <span>{{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.bankruptcyPreparationDepartment}}</span>
                </div>
                <div class="col-12">
                  <span> {{ infoItem.questionText }} </span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <naj-button
                v-if="infoItem.hasAttachment"
                type="button"
                color="default"
                icon="mdi-paperclip"
                @click="showAttachmentFile"
              >
              </naj-button>
              <span> {{ infoItem.answertext }}</span>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
        </v-col>
      </v-row>
      <render-attachment-modal
        :attachment-file="uploadedFile"
        :modal-visibility="showViewAttachmentModal"
        @modalClose="hideViewAttachmentModal"
      >
      </render-attachment-modal>
    </div>
  </template>
  <script>
  import { toHijriDate } from '@/helpers/utils';
  import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
  import { sessionStatus } from '@/helpers/enum';
  
  export default {
    name: 'BankruptcyCard',
    components: { RenderAttachmentModal },
    props: {
      infoItem: {
        default: null,
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showViewAttachmentModal: false,
        uploadedFile:{},
        sessionStatus,
      };
    },
    computed: {},
    methods: {
      toHijriDate,
      replyQuestion(answer) {
        this.$emit('onReplyQuestion', answer);
      },
      showAttachmentFile() {
        var isImageFile = false;
        var validImageTypes = ['.gif', '.jpeg', '.png', '.jpg'];
        if (validImageTypes.includes(this.infoItem.extention)) {
          isImageFile = true;
        }
        this.uploadedFile = {
          name: this.infoItem.attachName,
          sharePointId: this.infoItem.spid,
          isImage: isImageFile,
        };
        this.showViewAttachmentModal = true;
      },
      hideViewAttachmentModal() {
        this.showViewAttachmentModal = false;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .elitigation-block {
      border: 1px solid #ccc;
      border-radius: 10px;
      font-size: 14px;
      font-weight: bold;
  }
  .elitigation-block.question{
      background-color: #f8f8f9;
  }
  .reply-button-container {
    padding-left: 8px;
  }
  .elitigation-block.answer{
      background-color: #f8f8f9;
      border-right:5px solid #009587;
      margin-left: 10px;
  }
  .elitigation-block .judicial-department span{
  color: #009587 !important;
  }
  .next-icon{
    margin: 11px;
  }
  .person-name{
    color: #009587;
    margin-right: 8px;
  }
  .attach-file {
  margin-left: 10px;
  }
  </style>